<div class="column edit-toggle-page">
	@if (user) {
		<div class="content-container">
			<div class="content-container-header flex-row-end">
				<h3 class="flex-grow" i18n="@@userAbout-userDetails">User Details</h3>
				@if ((canEditUserData || canEditUserWhitelist) && this.isEditing === false) {
					<div class="spacing-24 flex-fixed">
						<button
							mat-button
							i18n="@@userAbout-edit"
							class="primary-button"
							(click)="isEditing = true"
							data-automation-id="user-about-edit-button"
						>
							Edit
						</button>
					</div>
				}
				@if (this.isEditing) {
					<div class="spacing-8 flex-fixed flex-row">
						<div class="flex-1">
							<button
								mat-button
								i18n="@@userAbout-cancel"
								class="secondary-button"
								(click)="isEditing = false"
								data-automation-id="user-about-cancel-button"
							>
								Cancel
							</button>
						</div>
						<div class="flex-1">
							<app-loading-indicator diameter="35" boxHeight="55" boxWidth="150">
								<button
									mat-button
									i18n="@@userAbout-saveChanges"
									class="primary-button"
									(click)="saveUser()"
									data-automation-id="user-about-save-changes-button"
								>
									Save Changes
								</button>
							</app-loading-indicator>
						</div>
					</div>
				}
			</div>
			<mat-divider></mat-divider>
			<div class="content-container-body column spacing-24">
				@if (!this.isEditing || !this.canEditUserData) {
					<div class="row">
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-50-grey" i18n="@@userAbout-firstName2">First Name</td>
									<td class="width-50-grey" i18n="@@userAbout-lastName2">Last Name</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ user.firstName }}</td>
									<td class="table-body-text">{{ user.lastName }}</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-50-grey" i18n="@@userAbout-email">Email Address</td>
									<td class="width-50-grey" i18n="@@userAbout-phoneNumber">Phone Number</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ user.email }}</td>
									<td class="table-body-text">
										{{ user.phoneNumber?.countryCode }} {{ user.phoneNumber | phoneNumber }}
									</td>
								</tr>
							</table>
						</div>
						<div>
							<table style="width: 100%">
								<div class="row spacing-24">
									<div class="mat-body-2 grey-font" i18n="@@userAbout-enableWhitelist">Enable Whitelist</div>
									<mat-slide-toggle
										[(ngModel)]="editUser.isWhitelisted"
										[disabled]="!isEditing || !canEditUserWhitelist"
										data-automation-id="whitelist-toggle-1"
									>
									</mat-slide-toggle>
								</div>
							</table>
						</div>
						@if (isOracle) {
							<div class="row top-bottom-padding">
								<table style="width: 100%">
									<tr class="mat-body-2">
										<td class="width-50-grey" colspan="2" i18n="@@userAbout-sluuId">SLUUID</td>
									</tr>
									<tr class="mat-body-3">
										<td class="table-body-text" colspan="2">{{ user.sluuId }}</td>
									</tr>
								</table>
							</div>
						}
					</div>
				} @else {
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@userAbout-first">First Name</mat-label>
							<input
								matInput
								[(ngModel)]="editUser.firstName"
								[disabled]="!canEditUserData"
								data-automation-id="first-name-input"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@userAbout-last">Last Name</mat-label>
							<input
								matInput
								[(ngModel)]="editUser.lastName"
								[disabled]="!canEditUserData"
								data-automation-id="last-name-input"
							/>
						</mat-form-field>
						<div class="column"></div>
					</div>
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@userAbout-email">Email Address</mat-label>
							<input
								matInput
								[(ngModel)]="editUser.email"
								[disabled]="!canEditUserData"
								data-automation-id="email-input"
							/>
						</mat-form-field>
						<app-contact-phone-type-form
							class="column"
							[isDisabled]="!canEditUserData"
							[existingPhoneNumber]="user.phoneNumber"
							(userPhoneNumber)="updateUserPhone($event)"
						></app-contact-phone-type-form>
						<div class="column"></div>
					</div>
					<div class="row spacing-24">
						<div i18n="@@userAbout-enableWhitelist2">Enable Whitelist</div>
						<mat-slide-toggle
							[(ngModel)]="editUser.isWhitelisted"
							[disabled]="!canEditUserData && !canEditUserWhitelist"
							data-automation-id="whitelist-toggle-2"
						>
						</mat-slide-toggle>
					</div>
				}
				<!-- User Edit Mode -->
			</div>
		</div>
	}

	@if (canSeeSecurityQuestion) {
		<div class="content-container column" style="margin-top: 24px">
			<mat-expansion-panel>
				<mat-expansion-panel-header>
					<mat-panel-title style="font-weight: bold" i18n="@@userAbout-SecurityQuestionDetails"
						>Security Question Details</mat-panel-title
					>
				</mat-expansion-panel-header>
				<mat-divider></mat-divider>
				<div class="content-container-body column spacing-24">
					<div class="row">
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-50-grey" i18n="@@userAbout-question">Question</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ displayQuestion }}</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-50-grey" i18n="@@userAbout-answer">Answer</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ displayAnswer }}</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</mat-expansion-panel>
		</div>
	}
</div>
